import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import type { IncidentSeverity, IncidentStatus, IncidentTaskStatus } from '../types/incident';

const statusColors: Record<IncidentStatus, string> = {
  DRAFT: 'default',
  OPEN: 'blue',
  IN_PROGRESS: 'processing',
  RESOLVED: 'green',
  CLOSED: 'default',
};

const taskStatusColors: Record<IncidentTaskStatus, string> = {
  OPEN: 'blue',
  IN_PROGRESS: 'processing',
  ON_HOLD: 'gold',
  RESOLVED: 'green',
  CLOSED: 'default',
};

const severityColors: Record<IncidentSeverity, string> = {
  low: 'default',
  medium: 'blue',
  high: 'orange',
  critical: 'red',
};

export const IncidentStatusTag = ({ status }: { status: IncidentStatus }) => {
  const { t } = useTranslation();
  return <Tag color={statusColors[status]}>{t(`incident.status.${status}`)}</Tag>;
};

export const IncidentSeverityTag = ({ severity }: { severity: IncidentSeverity }) => {
  const { t } = useTranslation();
  return <Tag color={severityColors[severity]}>{t(`incident.severity.${severity}`)}</Tag>;
};

export const IncidentTaskStatusTag = ({ status }: { status: IncidentTaskStatus }) => {
  const { t } = useTranslation();
  return <Tag color={taskStatusColors[status]}>{t(`incident.taskStatus.${status}`)}</Tag>;
};
